import { Component, Prop, Watch } from '@stencil/core';
import { getActionPermissions } from '@ugc-api/public';
import state from '@ugc-store';

@Component({
  tag: 'ugc-action-permission',
  shadow: false,
})
export class UgcActionPermission {
  @Prop() productId: number;
  @Prop() action: string[];

  async getActionPermissions(action) {
    try {
      const {
        preference: { language },
      } = state;
      return await getActionPermissions(this.productId, {
        action,
        languageCode: language,
      });
    } catch (e) {}
  }

  async getActionList() {
    if (this.productId) {
      const data = (await this.getActionPermissions(this.action)) as {
        [key: string]: {
          allowed: boolean;
        };
      };
      if (data) {
        state.actionPermission = {
          ...state.actionPermission,
          review: data.review ? !data.review.allowed : false,
          vote: data.vote ? !data.vote.allowed : false,
          question: data.question ? !data.question.allowed : false,
          answer: data.answer ? !data.answer.allowed : false,
        };
      }
    }
  }

  async componentWillLoad() {
    this.getActionList();
  }

  @Watch('productId')
  async watchProductIdHandler() {
    this.getActionList();
  }
}
